import { render, staticRenderFns } from "./list-open.vue?vue&type=template&id=0385c833&"
import script from "./list-open.vue?vue&type=script&lang=ts&"
export * from "./list-open.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports